/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect, useCallback, useContext } from 'react';
import { getTitleIconOutlet, getOutletShortAddress, getUpdatedReservationUrl } from '../../../modules/utils/helpers';
import {
  TRACKING_CONSTANT,
  OutletCuisines,
  outletNameLimit,
  PAGES,
  russiaLocale,
  RnBFILTERS,
} from '../../../modules/utils/constants';
/* eslint-disable @nx/enforce-module-boundaries */
import { PropertyCard } from '@marriott/mi-shop-components';
import { StyledPropertyCardContainer } from './SearchOutletCard.styles';
import { PageParamsContext } from '../../../modules/context';
import { eventUtil } from '@marriott/mi-ui-library';

const { EARN_REDEEM_PAGE } = PAGES;

export const SearchOutletCard = (props: any) => {
  const [fallbackDescriptionText, setFallbackDescriptionText] = useState<string>('');
  const [errorCheck, setErrorCheck] = useState(false);
  let isFallBackImage = false;
  let iconTitle;
  let styleClass = props?.restaurant?.node?.property?.basicInformation?.name ? 'trimmed-property-description' : '';
  const { currentPage, currentLocale } = useContext(PageParamsContext);

  const IMAGE_URL_DOMAIN = 'https://cache.marriott.com';

  const {
    SEARCH_RESULT_CARD,
    EARN_REDEEM_RECOMMENDATIONS,
    EARN_REDEEM_RECOMMENDATIONS_RESERVE_CTA,
    EARN_REDEEM_RECOMMENDATIONS_VIEWDETAILS_CTA,
    RESERVE_BUTTON,
    RESTAURANT_DETAILS_BUTTON,
    INTERNAL_LINK,
    EXTERNAL_LINK,
  } = TRACKING_CONSTANT;

  // const handleReserveBtnClick = () => {
  //   window.open(`${props.restaurant?.node?.reservationURL}`);
  // };
  const canPriceShow = props?.filtersOrderList?.some(
    (item: { filterName: string }) => item.filterName === RnBFILTERS.price
  );
  useEffect(() => {
    if (!props?.isMapView) window.dispatchEvent(new Event('resize'));
  }, [props?.isMapView]);

  const getFallbackDescription = useCallback(
    (firstDescription: string, secondDescription: string): string => {
      let fallbackDesc = '';
      if (
        props.restaurant?.node?.cuisine &&
        (props.restaurant?.node?.cuisine === OutletCuisines.other ||
          props.restaurant?.node?.cuisine === OutletCuisines.multicuisine)
      ) {
        fallbackDesc = secondDescription ? secondDescription : '';
      } else {
        fallbackDesc = firstDescription ? firstDescription : '';
      }

      if (!props?.isAuthorMode) {
        fallbackDesc = fallbackDesc.replace(/\[.*?\]/, props?.restaurant?.node?.name || '');
        let hotelName = props?.restaurant?.node?.seoUrl?.split('/')[1]?.split('-')?.slice(1) || '';
        hotelName = hotelName
          ? hotelName?.map((string: string) => string?.charAt(0)?.toUpperCase() + string?.slice(1))
          : '';
        fallbackDesc = fallbackDesc?.replace(/\[.*?\]/, hotelName ? hotelName?.join(' ') : ' ');
      }
      setFallbackDescriptionText(fallbackDesc);
      return fallbackDesc;
    },
    [
      props?.isAuthorMode,
      props?.restaurant?.node?.cuisine,
      props?.restaurant?.node?.name,
      props?.restaurant?.node?.seoUrl,
    ]
  );

  useEffect(() => {
    const isBannerAvlb =
      !!props?.restaurant?.node?.media?.imageConnection &&
      !!props?.restaurant?.node?.media?.imageConnection?.edges?.length;
    const isDescAvlb = !!props?.restaurant?.node?.description?.length;
    const isNameAvlb = !!props?.restaurant?.node?.name?.length;
    const isFallbackImg = !!props?.dynamicMedia;
    const isFallbackDesc = !!getFallbackDescription(props?.firstshortdescription, props?.secondshortdescription);

    const bannerOrFallback = isBannerAvlb === true || isFallbackImg === true;
    const descriptionOrFallback = isDescAvlb === true || isFallbackDesc === true;

    const errorCheck = bannerOrFallback === false || descriptionOrFallback === false || isNameAvlb === false;

    setErrorCheck(errorCheck);
  }, [
    getFallbackDescription,
    props?.dynamicMedia,
    props?.firstshortdescription,
    props?.restaurant,
    props?.secondshortdescription,
  ]);

  const getOutletTitle = () => {
    if (props.restaurant?.node?.description) {
      return props.restaurant?.node?.description.length > 242
        ? props.restaurant?.node?.description.slice(0, 242) + '[...]'
        : props.restaurant?.node?.description;
    } else if (!props?.restaurant?.node?.description && fallbackDescriptionText) {
      return fallbackDescriptionText?.length > 242
        ? fallbackDescriptionText.slice(0, 242) + '[...]'
        : fallbackDescriptionText;
    }
  };

  const getOutletName = () => {
    if (props?.restaurant?.node?.name?.length > outletNameLimit)
      styleClass = styleClass + ' ' + 'overridden-property-card-style';

    const titleDetails = {
      title: props?.restaurant?.node?.name,
      titleAriaLabel: props?.restaurant?.node?.name,
    };
    return titleDetails;
  };

  const getOutletIcon = () => {
    iconTitle = getTitleIconOutlet(props?.restaurant?.node);
    return iconTitle;
  };

  const getOutletImages = () => {
    const images: { defaultImageUrl: string } = {
      defaultImageUrl: '',
    };
    let defaultImageUrl = '';
    const outletImages = [];
    if (
      props?.restaurant?.node?.media?.imageConnection &&
      props?.restaurant?.node?.media?.imageConnection?.edges?.length === 1
    ) {
      if (props?.restaurant?.node?.media?.imageConnection?.edges[0]?.node?.cardImages[0]?.isFallBackImage) {
        defaultImageUrl = `${props?.restaurant?.node?.media?.imageConnection?.edges[0]?.node?.cardImages[0]?.dynamicMedia?.assetPath}`;
        images['defaultImageUrl'] = defaultImageUrl;
        outletImages.push(images);
        isFallBackImage = true;
      } else {
        defaultImageUrl = `${props?.restaurant?.node?.media?.imageConnection?.edges[0]?.node?.cardImages[0]?.defaultImageUrl}`;
        images['defaultImageUrl'] = defaultImageUrl;
        outletImages.push(images);
        isFallBackImage = false;
      }
    } else {
      const sortedImages = props?.restaurant?.node?.media?.imageConnection?.edges?.sort(function (a: any, b: any) {
        return (
          Number(b.node.isPrimaryArchitectural) - Number(a.node.isPrimaryArchitectural) ||
          Number(b.node.isPrimaryServices) - Number(a.node.isPrimaryServices) ||
          Number(b.node.isSecondaryArchitectural) - Number(a.node.isSecondaryArchitectural) ||
          Number(b.node.isSecondaryServices) - Number(a.node.isSecondaryServices)
        );
      });

      const trimmedImages = sortedImages?.slice(0, 5);
      trimmedImages?.forEach((element: any) => {
        defaultImageUrl = `${IMAGE_URL_DOMAIN}${element?.node?.imageUrls?.wideHorizontal}?downsize=504:*`;
        images['defaultImageUrl'] = defaultImageUrl;
        outletImages.push({ ...images });
      });
    }
    return outletImages;
  };

  const getTertiaryLinks = () => {
    const clicktrack_Pagespecific_reserve =
      currentPage === EARN_REDEEM_PAGE
        ? `${EARN_REDEEM_RECOMMENDATIONS}|${EARN_REDEEM_RECOMMENDATIONS_RESERVE_CTA}|${EXTERNAL_LINK}`
        : `${SEARCH_RESULT_CARD}|${RESERVE_BUTTON} on ${props.restaurant?.node?.name}|${EXTERNAL_LINK}`;
    if (props?.restaurant?.node?.basicInformation?.reservationUrl) {
      const footerlinks = {
        href: getUpdatedReservationUrl(
          props?.campaignParams,
          props?.restaurant?.node?.basicInformation?.reservationUrl,
          props?.restaurant?.node?.operationalDetails
        ),
        target: `${props?.reserveCtaOpenNewTab === true ? '_blank' : '_self'}`,
        custom_click_track_value: clicktrack_Pagespecific_reserve,
        rel: 'noreferrer',
        className: 'm-link-tertiary-button outlet-resevation-link custom_click_track ',
        buttonCopy: props?.reserveCtaLabel,
        isLink: true,
        // onClick: () => handleReserveBtnClick(),
      };
      return footerlinks;
    }
    return;
  };

  const getFooterLinks = () => {
    const clicktrack_Pagespecific_details =
      currentPage === EARN_REDEEM_PAGE
        ? `${EARN_REDEEM_RECOMMENDATIONS}|${EARN_REDEEM_RECOMMENDATIONS_VIEWDETAILS_CTA}|${INTERNAL_LINK}`
        : `${SEARCH_RESULT_CARD}|${RESTAURANT_DETAILS_BUTTON}|${INTERNAL_LINK}`;

    if (props.restaurant?.node?.seoUrl) {
      const footerlinks = {
        href: `${props?.currentLocale}/dining/${props.restaurant?.node?.seoUrl}.mi`,
        target: `${props?.restaurantsDetailsOpenNewTab === true ? '_blank' : '_self'}`,
        ratesClickTrackValue: clicktrack_Pagespecific_details,
        rel: 'noreferrer',
        className: 'm-button-s m-button-primary custom_click_track reserve-cta-button',
        text: props?.restaurantsDetailsCtaLabel,
        isLink: false,
        //   onClick: () => handleRestaurantBtnClick(),
      };
      return footerlinks;
    }
    return;
  };

  const getEyeBrowDetails = () => {
    let eyeBrowText = props?.restaurant?.node?.cuisine !== null ? props?.restaurant?.node?.cuisine : '';
    eyeBrowText =
      canPriceShow && props?.restaurant?.node?.diningExperience?.affordabilityPriceIndicator !== null
        ? eyeBrowText + ` | ${props?.restaurant?.node?.diningExperience?.affordabilityPriceIndicator}`
        : eyeBrowText;

    return eyeBrowText;
  };

  const showInfoWindowOnHover = (): void => {
    // send props?.restaurant once lat & long are obtainer from UXL
    if (props?.isMapView) {
      eventUtil.dispatch('showInfoWindow', props?.index);
    }
  };

  const hideInfoWindowOnUnHover = (): void => {
    if (props?.isMapView) {
      eventUtil.dispatch('hideInfoWindow', []);
    }
  };

  const PropertyCardProps = {
    titleDetails: getOutletName(),
    eyebrow: getEyeBrowDetails(),
    description: getOutletTitle(),
    carouselDotsPosition: 'center',
    images: getOutletImages(),
    tertiaryLinkDetails: getTertiaryLinks(),
    footerLinkDetails: getFooterLinks(),
    overlayIcon: isFallBackImage ? props?.iconPath : '',
    overlayText: isFallBackImage ? props?.overlayText : '',
    showIcon: true,
    iconTitle: getOutletIcon(),
    address: getOutletShortAddress(props?.restaurant?.node?.contactInformation, props) || '',
    propertyName: props?.restaurant?.node?.property?.basicInformation?.name || '',
    styleClass: currentLocale === russiaLocale ? styleClass + ' ru-locale-specific' : styleClass,
    isVerticalCard: props?.isVerticalCard || false,
    showDescriptionAlways: props?.showDescriptionAlways || false,
    iconPathDining: props?.iconPath,
    iconPathBar: props?.iconPathBar,
    showMobileVariantOnly: props?.isMapView,
  };

  return errorCheck === false ? (
    <StyledPropertyCardContainer
      className="search-outlet-card"
      // send props?.restaurant once lat & long are obtainer from UXL
      onMouseEnter={(): void => showInfoWindowOnHover()}
      onMouseLeave={hideInfoWindowOnUnHover}
    >
      <PropertyCard {...PropertyCardProps} />
    </StyledPropertyCardContainer>
  ) : null;
};
